import React, { useEffect, useRef, useState } from 'react';
import './SynopsisTab.scss';
import KodanshaUnderlinedText from '../../../KodanshaUIKit/KodanshaUnderlinedText/KodanshaUnderlinedText';
import Rating from '../Rating/Rating';
import { Readable } from '../../../../Models/Product/Readable';

interface Props {
    synopsisText: string;
    readable: Readable;
    ageRating: string;
    trim?: string;
}

const SynopsisTab = ({ synopsisText, ageRating, readable, trim }: Props) => {
    const [more, setMore] = useState(false);
    const [tab, setTab] = useState(0);
    const descriptionRef = useRef(null);

    useEffect(() => {
        if (!descriptionRef.current) {
            return;
        }

        if ((descriptionRef.current && descriptionRef.current.clientHeight) && (descriptionRef.current.clientHeight >= descriptionRef.current.scrollHeight)) {
            setMore(true);
        }
    }, [synopsisText]);

    return (
        <div className='synopsis-tab-container'>

            <div className='synopsis-tab-tabs-wrapper'>
                <h3 onClick={() => setTab(0)} className={`${tab === 0 && 'h3-active'}`}>Volume info</h3>
                <h3 onClick={() => setTab(1)} className={`${tab === 1 && 'h3-active'}`}>Synopsis</h3>
            </div>


            {tab === 0 ?
                <div className='rating-margin'>
                    <Rating readable={readable} ageRating={ageRating} trim={trim} />
                </div>
                : <>
                    {/*<h3 className={'synopsis-header'}>Synopsis</h3>*/}
                    {/*<div className={'synopsis-divider'} />*/}
                    <div ref={descriptionRef} className={'mobile-description-wrapper'}
                         dangerouslySetInnerHTML={{ __html: synopsisText }}
                         style={{ display: more && 'flex' }}>
                    </div>
                    {!more &&
                        <KodanshaUnderlinedText text={'Read More'} onClick={() => setMore(true)} />}
                </>}

        </div>
    );
};

export default SynopsisTab;